import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Asentamientos from './Asentamientos';

const preguntasObligatorias = [
  { key: 'edad', label: 'Edad', num: 1 },
  { key: 'genero', label: 'Género', num: 2 },
  { key: 'colonia', label: '¿En qué colonia vives?', num: 3 },
  { key: 'ocupacion', label: 'Ocupación principal', num: 4 },
  { key: 'medioTransportePublico', label: '¿Qué medio(s) de transporte público usas más?', num: 5 },
  { key: 'llegadaParada', label: '¿Cómo llegas a las paradas del transporte público?', num: 6 },
  { key: 'frecuenciaUsoPublico', label: '¿Qué tan seguido usas el transporte público?', num: 7 },
  { key: 'motivoUsoPublico', label: '¿Para qué sueles usar el transporte público?', num: 8 },
  { key: 'horaUsoPublico', label: '¿A qué hora sueles usar el transporte público?', num: 9 },
  { key: 'destinoFrecuente', label: 'Anota tu destino más frecuente', num: 10 },
  { key: 'coloniaDestinoFrecuente', label: 'Anota la colonia de tu destino más frecuente', num: 10 },
  { key: 'unidadesTransporteDestino', label: '¿Cuántas unidades de transporte necesitas para llegar a tu destino más frecuente?', num: 11 },
  { key: 'tiempoTotalViajeIda', label: '¿Cuánto tiempo total te toma este viaje de ida?', num: 12 },
  { key: 'calificacionTiempoViaje', label: '¿Cómo calificarías este tiempo de viaje?', num: 13 },
  { key: 'cuadrasDesplazamientoIda', label: '¿Cuántas cuadras tienes que caminar o desplazarte para llegar a tu destino?', num: 14 },
  { key: 'calificacionDistanciaDesplazamiento', label: '¿Cómo calificarías esta distancia?', num: 15 },
  { key: 'percepcionGasto', label: '¿Cómo percibes tu gasto en transporte público?', num: 16 },
  { key: 'distanciaParada', label: 'Está muy lejos la parada más cercana', num: 17 },
  { key: 'multitudEspera', label: 'Hay mucha gente y el tiempo de espera es largo', num: 17 },
  { key: 'frecuenciaBus', label: 'Tardan mucho en pasar los autobuses', num: 17 },
  { key: 'ocupacionBus', label: 'Los autobuses van muy llenos', num: 17 },
  { key: 'estacionamientoBici', label: 'No hay dónde estacionar mi bici', num: 17 },
  { key: 'mantenimientoBus', label: 'Los autobuses están en mal estado o sin mantenimiento', num: 17 },
  { key: 'paradasDeterioradas', label: 'Las paradas de autobús están deterioradas', num: 17 },
  { key: 'paradasIncomodas', label: 'Las paradas de autobús son incómodas', num: 17 },
  { key: 'paradasSucias', label: 'Las paradas están sucias', num: 17 },
  { key: 'trayectosLargos', label: 'Los trayectos son muy largos', num: 17 },
  { key: 'miedoInseguridad', label: '¿Alguna vez has sentido miedo o inseguridad en el trayecto o en la parada de autobuses?', num: 18 },
  { key: 'banquetaAncha', label: '¿Consideras que las banquetas son suficientemente anchas?', num: 19 },
  { key: 'obstaculosBanquetas', label: '¿Cuáles son los principales obstáculos que te impiden caminar por las banquetas?', num: 20 },
  { key: 'alumbradoAdecuado', label: '¿Es adecuado el alumbrado en las vías y en las paradas de autobús?', num: 21 },
  { key: 'sombraArboles', label: '¿Hay suficientes árboles adecuados para dar sombra por donde caminas?', num: 22 },
  { key: 'frecuenciaInundaciones', label: '¿Qué tan frecuente es que charcos o inundaciones obstruyan el paso?', num: 23 },
  { key: 'conectividadTransporte', label: 'En general, ¿Qué tan bien consideras que está conectada la ciudad con el transporte público? (1 siendo muy mala, 5 excelente)', num: 24 },
  { key: 'mejoraMovilidadCiudad', label: '¿Qué mejorarías para moverte más fácilmente dentro de la ciudad?', num: 25 }
];

const Encuesta = () => {
  const navigate = useNavigate();

  const refs = useRef({});
  preguntasObligatorias.forEach(({ key }) => {
    if (!refs.current[key]) refs.current[key] = React.createRef();
  });

  const [formData, setFormData] = useState({
    edad: '',
    genero: '',
    colonia: '',
    ocupacion: '',
    otroOcupacion: '',

    medioTransportePublico: [],
    llegadaParada: [],
    frecuenciaUsoPublico: '',
    motivoUsoPublico: [],
    otroMotivoUsoPublico: '',
    horaUsoPublico: [],

    destinoFrecuente: '',
    coloniaDestinoFrecuente: '',
    unidadesTransporteDestino: '',
    tiempoTotalViajeIda: '',
    calificacionTiempoViaje: '',
    cuadrasDesplazamientoIda: '',
    calificacionDistanciaDesplazamiento: '',
    percepcionGasto: '',

    distanciaParada: '',
    multitudEspera: '',
    frecuenciaBus: '',
    ocupacionBus: '',
    estacionamientoBici: '',
    mantenimientoBus: '',
    paradasDeterioradas: '',
    paradasIncomodas: '',
    paradasSucias: '',
    trayectosLargos: '',
    otroAfectacion: '',

    miedoInseguridad: '',
    paradasAccesibles: '',

    banquetaAncha: '',
    obstaculosBanquetas: [],
    otroObstaculoBanquetas: '',
    pasosPeatonales: '',
    prioridadPeatonal: '',
    alumbradoAdecuado: '',
    sombraArboles: '',
    autosObstruyen: '',
    frecuenciaInundaciones: '',

    conectividadTransporte: '',
    mejoraMovilidadCiudad: ''
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const arrayFields = [
      'medioTransportePublico',
      'llegadaParada',
      'motivoUsoPublico',
      'horaUsoPublico',
      'obstaculosBanquetas'
    ];

    if (type === 'checkbox' && arrayFields.includes(name)) {
      let updated = [...formData[name]];
      if (checked) {
        updated.push(value);
      } else {
        updated = updated.filter((item) => item !== value);
      }
      setFormData({ ...formData, [name]: updated });

    } else if (type === 'checkbox') {
      setFormData({ ...formData, [name]: checked });

    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let camposFaltantes = [];
    let primerCampoFaltanteKey = null;

    for (const { key, label, num } of preguntasObligatorias) {
      const valor = formData[key];
      const esVacio =
        valor === '' ||
        (Array.isArray(valor) && valor.length === 0);
      if (esVacio) {
        camposFaltantes.push({ key, label, num });
        if (!primerCampoFaltanteKey) primerCampoFaltanteKey = key;
      }
    }

    if (formData.ocupacion === 'Otro (especificar)' && (formData.otroOcupacion || '').trim() === '') {
      camposFaltantes.push({ key: 'otroOcupacion', label: 'Especificar ocupación', num: 4 });
      if (!primerCampoFaltanteKey) primerCampoFaltanteKey = 'otroOcupacion';
    }
    if (formData.motivoUsoPublico.includes('Otro (especificar)') && (formData.otroMotivoUsoPublico || '').trim() === '') {
      camposFaltantes.push({ key: 'otroMotivoUsoPublico', label: 'Especificar motivo de uso', num: 8 });
      if (!primerCampoFaltanteKey) primerCampoFaltanteKey = 'otroMotivoUsoPublico';
    }
    if (
      formData.conectividadTransporte !== '' &&
      (!Number.isInteger(Number(formData.conectividadTransporte)) ||
        Number(formData.conectividadTransporte) < 1 ||
        Number(formData.conectividadTransporte) > 5)
    ) {
      camposFaltantes.push({
        key: 'conectividadTransporte',
        label: 'La conectividad debe ser un número del 1 al 5.',
        num: 24
      });
      if (!primerCampoFaltanteKey) primerCampoFaltanteKey = 'conectividadTransporte';
    }

    if (camposFaltantes.length > 0) {
      const lista = camposFaltantes
        .map(c => `- ${c.num ? c.num + '. ' : ''}${c.label}`)
        .join('\n');

      setTimeout(() => {
        if (refs.current[primerCampoFaltanteKey] && refs.current[primerCampoFaltanteKey].current) {
          refs.current[primerCampoFaltanteKey].current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);

      alert(`Por favor completa los siguientes campos antes de enviar:\n\n${lista}`);
      return;
    }

    try {
      const response = await fetch('/api/survey', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        await response.json();
        alert('Encuesta enviada. Gracias por participar.');
        navigate('/');
      } else {
        console.error('Error en el servidor:', response.statusText);
        alert('Hubo un problema al enviar la encuesta. Inténtalo de nuevo.');
      }
    } catch (error) {
      console.error('Error al enviar la encuesta:', error);
      alert('Ocurrió un error inesperado. Intenta de nuevo más tarde.');
    }
  };

  const handleReturn = () => {
    navigate('/');
  };

  const containerStyle = {
    backgroundColor: '#FFD437',
    padding: '20px',
    borderRadius: '8px',
    maxWidth: '800px',
    width: '90%',
    margin: '20px auto',
    fontFamily: 'Arial, sans-serif'
  };
  const headerStyle = { color: '#305E67', textAlign: 'center', marginBottom: '10px' };
  const subHeaderStyle = { color: '#09BAC4', textAlign: 'center', marginBottom: '20px', fontSize: '1.8rem' };
  const sectionStyle = {
    marginBottom: '30px',
    backgroundColor: '#fff',
    padding: '15px',
    borderRadius: '8px',
    overflow: 'auto'
  };
  const sectionHeaderStyle = {
    color: '#305E67',
    borderBottom: '2px solid #09BAC4',
    paddingBottom: '10px',
    marginBottom: '20px'
  };
  const questionBlockStyle = { marginBottom: '20px' };
  const buttonStyle = {
    backgroundColor: '#09BAC4',
    color: '#fff',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'block',
    margin: '20px auto'
  };
  const returnButtonStyle = { ...buttonStyle, backgroundColor: '#305E67', marginTop: '10px' };

  // --- FORMULARIO ---
  return (
    <div style={containerStyle}>
      <style>{`
  * { box-sizing: border-box; }
  .question-text {
    font-size: 2.4rem;
    font-weight: bold;
    margin-bottom: 7px;
    display: block;
  }
  .respuesta-text {
    font-size: 1.45rem;
  }
  .radio-group, .checkbox-group { 
    display: flex; 
    flex-direction: column; 
    align-items: flex-start; 
  }
  .radio-group label, .checkbox-group label { 
    margin-bottom: 8px; 
    text-align: left; 
  }
  .tabla-enunciado { 
    font-size: 1.5rem;  
    font-weight: normal; 
    text-align: left; 
    display: block; 
  }
  .table-container, .table-responsive { 
    margin-top: 10px; 
    overflow-x: auto; 
  }
  .table-container table, .table-responsive table { 
    width: 100%; 
    border-collapse: collapse; 
    table-layout: fixed; 
  }
  .table-container th, .table-container td, .table-responsive th, .table-responsive td { 
    text-align: center; 
    padding: 8px; 
    border: 1px solid #000;
  }
  .table-container input, .table-responsive input { 
    width: 90%; 
    margin: 0 auto; 
    text-align: center; 
  }
  .respuesta-text input[type="radio"],
  .respuesta-text input[type="checkbox"] {
    width: 1.4rem;
    height: 1.4rem;
    margin-right: 8px;
    vertical-align: middle;
  }

  /* --------- ALINEACIÓN PERFECTA PARA LA TABLA DE LA PREGUNTA 13 --------- */
  .alinear-fila {
    display: grid;
    grid-template-columns: 1fr 0.25fr 0.25fr 0.25fr;
    align-items: center;
    width: 100%;
  }
  .alinear-fila td, .alinear-fila th {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #eee;
    padding: 8px;
  }
  .alinear-fila td.tabla-enunciado {
    justify-content: flex-start;
    text-align: left;
  }
  .alinear-fila:last-child td {
    border-bottom: none;
  }
  .table-responsive thead tr {
    display: grid;
    grid-template-columns: 1fr 0.25fr 0.25fr 0.25fr;
  }
  .table-responsive th {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 480px) {
    h1 { font-size: 1.2rem; }
    h2 { font-size: 1rem; }
    .question-text { font-size: 0.97rem; }
    .respuesta-text { font-size: 1.05rem; }
    .respuesta-text input[type="radio"],
    .respuesta-text input[type="checkbox"] {
      width: 1.05rem;
      height: 1.05rem;
    }
    .tabla-enunciado { font-size: 1.05rem; }
    label { font-size: 0.95rem; }
    input, textarea { font-size: 0.9rem; }
    .alinear-fila {
      grid-template-columns: 1fr 0.3fr 0.3fr 0.3fr;
    }
    .table-responsive thead tr {
      grid-template-columns: 1fr 0.3fr 0.3fr 0.3fr;
    }
  }
  @media (min-width: 768px) {
    .radio-group, .checkbox-group {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 0.5rem 2rem;
    }
  }
`}</style>

      <h1 style={headerStyle}>Encuesta sobre movilidad urbana y experiencia en el transporte público</h1>
      <p style={subHeaderStyle}>
        Esta encuesta tiene como objetivo conocer la experiencia de las y los usuarios del transporte público en la ciudad de Mérida. ¡Gracias por tu participación!
      </p>

      <form onSubmit={handleSubmit}>
        {/* PRIMERA SECCIÓN */}
        <section style={sectionStyle}>
          <h2 style={sectionHeaderStyle}>UN POCO SOBRE TI…</h2>
          <div style={questionBlockStyle} ref={refs.current['edad']}>
            <p className="question-text">1. Edad:</p>
            <div className="radio-group">
              {['Menos de 18 años','18-25 años','26-35 años','36-45 años','46-60 años','Más de 60 años'].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="radio"
                    name="edad"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.edad === opt}
                  />{' '}
                  {opt}
                </label>
              ))}
            </div>
          </div>
          <div style={questionBlockStyle} ref={refs.current['genero']}>
            <p className="question-text">2. Género:</p>
            <div className="radio-group">
              {['Femenino','Masculino','Transgénero','No binario','Prefiero no decirlo'].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="radio"
                    name="genero"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.genero === opt}
                  />{' '}
                  {opt}
                </label>
              ))}
            </div>
          </div>
          <div style={questionBlockStyle} ref={refs.current['colonia']}>
            <p className="question-text">3. ¿En qué colonia o localidad vives?</p>
            <Asentamientos formData={formData} setFormData={setFormData} />
          </div>
          <div style={questionBlockStyle} ref={refs.current['ocupacion']}>
            <p className="question-text">4. Ocupación principal:</p>
            <div className="radio-group">
              {['Empleador(a)','Autoempleado(a)','Trabajador(a)','Amo(a) de casa','Estudiante','Desempleado(a)','Retirado(a)','Otro (especificar)'].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="radio"
                    name="ocupacion"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.ocupacion === opt}
                  />{' '}
                  {opt}
                </label>
              ))}
              {formData.ocupacion === 'Otro (especificar)' && (
                <input
                  type="text"
                  name="otroOcupacion"
                  placeholder="Especificar"
                  value={formData.otroOcupacion}
                  onChange={handleInputChange}
                  style={{ marginLeft: '10px' }}
                  ref={refs.current['otroOcupacion']}
                />
              )}
            </div>
          </div>
        </section>

        {/* SEGUNDA SECCIÓN */}
        <section style={sectionStyle}>
          <h2 style={sectionHeaderStyle}>CUÉNTANOS CÓMO TE MUEVES POR LA CIUDAD…</h2>
          <div style={questionBlockStyle} ref={refs.current['medioTransportePublico']}>
            <p className="question-text">5. ¿Qué medio(s) de transporte público usas más?</p>
            <div className="checkbox-group">
              {['Autobús','Va y Ven','IE Tram','Combis','Mototaxi'].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="checkbox"
                    name="medioTransportePublico"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.medioTransportePublico.includes(opt)}
                  />{' '}
                  {opt}
                </label>
              ))}
            </div>
          </div>
          <div style={questionBlockStyle} ref={refs.current['llegadaParada']}>
            <p className="question-text">6. ¿Cómo llegas a las paradas del transporte público?</p>
            <div className="checkbox-group">
              {['Caminando','Bicicleta','Coche','Mototaxi'].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="checkbox"
                    name="llegadaParada"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.llegadaParada.includes(opt)}
                  />{' '}
                  {opt}
                </label>
              ))}
            </div>
          </div>
          <div style={questionBlockStyle} ref={refs.current['frecuenciaUsoPublico']}>
            <p className="question-text">7. ¿Qué tan seguido usas el transporte público?</p>
            <div className="radio-group">
              {['Diario','3-5 veces por semana','1-2 veces por semana','1-2 veces al mes'].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="radio"
                    name="frecuenciaUsoPublico"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.frecuenciaUsoPublico === opt}
                  />{' '}
                  {opt}
                </label>
              ))}
            </div>
          </div>
          <div style={questionBlockStyle} ref={refs.current['motivoUsoPublico']}>
            <p className="question-text">8. ¿Para qué sueles usar el transporte público?</p>
            <div className="checkbox-group">
              {[
                'Ir o volver del trabajo',
                'Ir o volver de la escuela o universidad',
                'Llevar o traer niños o niñas a la escuela',
                'Hacer compras (como despensa, mercado, etc.)',
                'Ir al médico o a consultas de salud',
                'Hacer trámites (como pagos, documentos, etc.)',
                'Acompañar o cuidar a alguien que no puede moverse solo/a',
                'Salir por gusto, diversión o descanso',
                'Otro (especificar)'
              ].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="checkbox"
                    name="motivoUsoPublico"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.motivoUsoPublico.includes(opt)}
                  />{' '}
                  {opt}
                </label>
              ))}
              {formData.motivoUsoPublico.includes('Otro (especificar)') && (
                <input
                  type="text"
                  name="otroMotivoUsoPublico"
                  placeholder="Especificar"
                  value={formData.otroMotivoUsoPublico}
                  onChange={handleInputChange}
                  style={{ marginLeft: '10px' }}
                  ref={refs.current['otroMotivoUsoPublico']}
                />
              )}
            </div>
          </div>
          <div style={questionBlockStyle} ref={refs.current['horaUsoPublico']}>
            <p className="question-text">9. ¿A qué hora sueles usar el transporte público?</p>
            <div className="checkbox-group">
              {[
                'Muy temprano en la mañana (antes de las 6:00 a.m.)',
                'Mañana (entre 6:00 a.m. y 11:00 a.m.)',
                'Mediodía o tarde (entre 11:00 a.m. y 4:00 p.m.)',
                'Tarde-noche (entre 4:00 p.m. y 8:00 p.m.)',
                'Noche (después de las 8:00 p.m.)',
                'Varía mucho / No hay un horario fijo'
              ].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="checkbox"
                    name="horaUsoPublico"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.horaUsoPublico.includes(opt)}
                  />{' '}
                  {opt}
                </label>
              ))}
            </div>
            <h2 style={sectionHeaderStyle}>
              CUÉNTANOS CUÁNTO TIEMPO TE TOMA IR A TU DESTINO MÁS FRECUENTE Y QUÉ TANTO TIENES QUE CAMINAR O DESPLAZARTE PARA HACERLO...
            </h2>
          </div>

          <div style={questionBlockStyle} ref={refs.current['destinoFrecuente']}>
            <p className="question-text">
              10. Anota tu destino más frecuente y la colonia en la que se encuentra (ej. escuela - Caucel).
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '10px', marginTop: '10px' }}>
              <input
                type="text"
                name="destinoFrecuente"
                value={formData.destinoFrecuente}
                onChange={handleInputChange}
                placeholder="Destino más frecuente"
              />
              <input
                type="text"
                name="coloniaDestinoFrecuente"
                value={formData.coloniaDestinoFrecuente}
                onChange={handleInputChange}
                placeholder="Colonia del destino"
                ref={refs.current['coloniaDestinoFrecuente']}
              />
            </div>
          </div>

          <div style={questionBlockStyle} ref={refs.current['unidadesTransporteDestino']}>
            <p className="question-text">
              11. ¿Cuántas unidades de transporte (autobuses, combis, etc.) necesitas para llegar a ese destino?
            </p>
            <div className="radio-group">
              {['Solo 1 unidad', '2 unidades', '3 o más unidades'].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="radio"
                    name="unidadesTransporteDestino"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.unidadesTransporteDestino === opt}
                  />{' '}
                  {opt}
                </label>
              ))}
            </div>
          </div>

          <div style={questionBlockStyle} ref={refs.current['tiempoTotalViajeIda']}>
            <p className="question-text">
              12. En promedio, ¿cuánto tiempo total (puerta a puerta) te toma este viaje de IDA?
            </p>
            <div className="radio-group">
              {[
                'Menos de 15 minutos',
                '15 a 30 minutos',
                '31 a 60 minutos (1 hora)',
                '1 hora a 1 hora y 30 minutos',
                'Más de 1 hora y 30 minutos'
              ].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="radio"
                    name="tiempoTotalViajeIda"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.tiempoTotalViajeIda === opt}
                  />{' '}
                  {opt}
                </label>
              ))}
            </div>
          </div>

          <div style={questionBlockStyle} ref={refs.current['calificacionTiempoViaje']}>
            <p className="question-text">13. ¿Cómo calificarías este tiempo de viaje?</p>
            <div className="radio-group">
              {[
                'Aceptable / Corto',
                'Moderado / Es lo que toma el viaje',
                'Excesivo / Demasiado largo'
              ].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="radio"
                    name="calificacionTiempoViaje"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.calificacionTiempoViaje === opt}
                  />{' '}
                  {opt}
                </label>
              ))}
            </div>
          </div>

          <div style={questionBlockStyle} ref={refs.current['cuadrasDesplazamientoIda']}>
            <p className="question-text">
              14. En total, ¿cuántas cuadras tienes que caminar o desplazarte (caminando, en bici o de aventón) para llegar al paradero o moverte entre paraderos, para llegar a tu destino (de ida)?
            </p>
            <div className="radio-group">
              {['2 o menos cuadras', '3 a 5 cuadras', '6 a 10 cuadras', 'Más de 10 cuadras'].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="radio"
                    name="cuadrasDesplazamientoIda"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.cuadrasDesplazamientoIda === opt}
                  />{' '}
                  {opt}
                </label>
              ))}
            </div>
          </div>

          <div style={questionBlockStyle} ref={refs.current['calificacionDistanciaDesplazamiento']}>
            <p className="question-text">15. ¿Cómo calificarías esta distancia?</p>
            <div className="radio-group">
              {[
                'Aceptable / Cómoda',
                'Moderada (Aceptable, pero es un esfuerzo)',
                'Excesiva / Muy lejos'
              ].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="radio"
                    name="calificacionDistanciaDesplazamiento"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.calificacionDistanciaDesplazamiento === opt}
                  />{' '}
                  {opt}
                </label>
              ))}
            </div>
          </div>
        </section>

        <section style={sectionStyle}>
          <h2 style={sectionHeaderStyle}>OTROS ASPECTOS DEL TRANSPORTE PÚBLICO…</h2>

          <div style={questionBlockStyle} ref={refs.current['percepcionGasto']}>
            <p className="question-text">16. ¿Cómo percibes tu gasto en transporte público?</p>
            <div className="radio-group">
              {[
                'No es un gasto significativo para mí',
                'Es un gasto moderado pero manejable',
                'Es un gasto importante en mi economía',
                'Es un gasto muy alto y me limita en otros aspectos'
              ].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="radio"
                    name="percepcionGasto"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.percepcionGasto === opt}
                  />{' '}
                  {opt}
                </label>
              ))}
            </div>
          </div>

          <div style={questionBlockStyle} ref={refs.current['distanciaParada']}>
            <p className="question-text">
              17. ¿Cuáles de estas situaciones te afectan al usar el transporte público?
            </p>
            <div className="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>Situación</th>
                    <th>Sí</th>
                    <th>No</th>
                    <th>A veces</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { key: 'distanciaParada', label: 'Está muy lejos la parada más cercana' },
                    { key: 'multitudEspera', label: 'Hay mucha gente y el tiempo de espera es largo' },
                    { key: 'frecuenciaBus', label: 'Tardan mucho en pasar los autobuses' },
                    { key: 'ocupacionBus', label: 'Los autobuses van muy llenos' },
                    { key: 'estacionamientoBici', label: 'No hay dónde estacionar mi bici' },
                    { key: 'mantenimientoBus', label: 'Los autobuses están en mal estado o sin mantenimiento' },
                    { key: 'paradasDeterioradas', label: 'Las paradas de autobús están deterioradas' },
                    { key: 'paradasIncomodas', label: 'Las paradas de autobús son incómodas (sin sombra, sin asientos, etc.)' },
                    { key: 'paradasSucias', label: 'Las paradas están sucias' },
                    { key: 'trayectosLargos', label: 'Los trayectos son muy largos' }
                  ].map(item => (
                    <tr key={item.key} ref={refs.current[item.key]} className="alinear-fila">
                      <td className="tabla-enunciado">{item.label}</td>
                      <td>
                        <label className="respuesta-text">
                          <input
                            type="radio"
                            name={item.key}
                            value="Sí"
                            onChange={handleInputChange}
                            checked={formData[item.key] === 'Sí'}
                          />
                          Sí
                        </label>
                      </td>
                      <td>
                        <label className="respuesta-text">
                          <input
                            type="radio"
                            name={item.key}
                            value="No"
                            onChange={handleInputChange}
                            checked={formData[item.key] === 'No'}
                          />
                          No
                        </label>
                      </td>
                      <td>
                        <label className="respuesta-text">
                          <input
                            type="radio"
                            name={item.key}
                            value="A veces"
                            onChange={handleInputChange}
                            checked={formData[item.key] === 'A veces'}
                          />
                          A veces
                        </label>
                      </td>
                    </tr>
                  ))}
                  <tr className="alinear-fila">
                    <td className="tabla-enunciado">
                      Otro (especificar):
                      <input
                        type="text"
                        name="otroAfectacion"
                        value={formData.otroAfectacion}
                        onChange={handleInputChange}
                        placeholder="Especificar..."
                        style={{ width: '100%', marginTop: '5px' }}
                      />
                    </td>
                    <td colSpan="3"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div style={questionBlockStyle} ref={refs.current['miedoInseguridad']}>
            <p className="question-text">
              18. ¿Alguna vez has sentido miedo o inseguridad en el trayecto o en la parada de autobuses
              por alguna situación de robo, acoso, discriminación, etc.?
            </p>
            <div className="radio-group">
              {['Sí', 'No'].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="radio"
                    name="miedoInseguridad"
                    value={opt}
                    checked={formData.miedoInseguridad === opt}
                    onChange={handleInputChange}
                  />{' '}
                  {opt}
                </label>
              ))}
            </div>
          </div>
        </section>

        <section style={sectionStyle}>
          <h2 style={sectionHeaderStyle}>SOBRE LA MOVILIDAD PEATONAL</h2>

          <div style={questionBlockStyle} ref={refs.current['banquetaAncha']}>
            <p className="question-text">
              19. ¿Consideras que las banquetas son suficientemente anchas para caminar en ellas?
            </p>
            <div className="radio-group">
              {['Sí','No'].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="radio"
                    name="banquetaAncha"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.banquetaAncha === opt}
                  />{' '}
                  {opt}
                </label>
              ))}
            </div>
          </div>

          <div style={questionBlockStyle} ref={refs.current['obstaculosBanquetas']}>
            <p className="question-text">
              20. ¿Cuáles son los principales obstáculos que te impiden caminar por las banquetas?
            </p>
            <div className="checkbox-group">
              {[
                'Banqueta rota',
                'Raíces de árboles',
                'Escalones',
                'Vendedores ambulantes o puestos de comida',
                'Vegetación',
                'Basura o cacharros',
                'Charcos o áreas inundadas',
                'Otra'
              ].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="checkbox"
                    name="obstaculosBanquetas"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.obstaculosBanquetas.includes(opt)}
                  />{' '}
                  {opt}
                </label>
              ))}
              {formData.obstaculosBanquetas.includes('Otra') && (
                <input
                  type="text"
                  name="otroObstaculoBanquetas"
                  placeholder="Especificar"
                  value={formData.otroObstaculoBanquetas}
                  onChange={handleInputChange}
                  style={{ marginLeft: '10px', width: '90%' }}
                />
              )}
            </div>
          </div>

          <div style={questionBlockStyle} ref={refs.current['alumbradoAdecuado']}>
            <p className="question-text">
              21. ¿Es adecuado el alumbrado en las vías y en las paradas de autobús?
            </p>
            <div className="radio-group">
              {['Sí','No'].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="radio"
                    name="alumbradoAdecuado"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.alumbradoAdecuado === opt}
                  />{' '}
                  {opt}
                </label>
              ))}
            </div>
          </div>

          <div style={questionBlockStyle} ref={refs.current['sombraArboles']}>
            <p className="question-text">22. ¿Hay suficientes árboles para dar sombra por donde caminas?</p>
            <div className="radio-group">
              {['Sí','No'].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="radio"
                    name="sombraArboles"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.sombraArboles === opt}
                  />{' '}
                  {opt}
                </label>
              ))}
            </div>
          </div>

          <div style={questionBlockStyle} ref={refs.current['frecuenciaInundaciones']}>
            <p className="question-text">23. Durante la temporada de lluvias, ¿Qué tan frecuente es que charcos o inundaciones obstruyan el paso?</p>
            <div className="radio-group">
              {['Nunca o casi nunca','A veces','Siempre o casi siempre'].map(opt => (
                <label key={opt} className="respuesta-text">
                  <input
                    type="radio"
                    name="frecuenciaInundaciones"
                    value={opt}
                    onChange={handleInputChange}
                    checked={formData.frecuenciaInundaciones === opt}
                  />{' '}
                  {opt}
                </label>
              ))}
            </div>
          </div>

          <div style={questionBlockStyle} ref={refs.current['conectividadTransporte']}>
            <p className="question-text">
              24. En general, ¿Qué tan bien consideras que está conectada la ciudad con el transporte público? (1 siendo muy mala, 5 excelente)
            </p>
            <input
              type="number"
              min="1"
              max="5"
              name="conectividadTransporte"
              value={formData.conectividadTransporte}
              onChange={handleInputChange}
              placeholder="Escribe un valor del 1 al 5"
              style={{ width: '220px' }}
            />
          </div>
        </section>

        <section style={sectionStyle}>
          <h2 style={sectionHeaderStyle}>Y FINALMENTE…</h2>

          <div style={questionBlockStyle} ref={refs.current['mejoraMovilidadCiudad']}>
            <p className="question-text">
              25. ¿Qué mejorarías para moverte más fácilmente dentro de la ciudad?
            </p>
            <textarea
              name="mejoraMovilidadCiudad"
              value={formData.mejoraMovilidadCiudad}
              onChange={handleInputChange}
              placeholder="Escribe tu respuesta"
              rows={4}
              style={{ width: '100%', resize: 'vertical' }}
            />
          </div>
        </section>

        <button type="submit" style={buttonStyle}>Enviar</button>
      </form>

      <button type="button" style={returnButtonStyle} onClick={handleReturn}>
        Volver a Lab-DEMOSS
      </button>
    </div>
  );
};

export default Encuesta;
